import BenchlingConfig from 'BenchlingConfig';

export {ModelHubEnablementState} from 'graphql-client/__generated/graphqlGlobalTypes';

export function isScientificAIModelsSectionVisible(): boolean {
  return BenchlingConfig.MODEL_HUB_TAC_PERMISSIONS_ENABLED;
}

export function canRunScientificAIviaTAC(): boolean {
  if (!BenchlingConfig.MODEL_HUB_TAC_PERMISSIONS_ENABLED) {
    return true;
  }
  return BenchlingConfig.MODEL_HUB_SCIENTIFIC_AI_USER_TAC_ENABLED;
}

export function getScientificAIDisabledMessage(): string | null {
  if (canRunScientificAIviaTAC()) {
    return null;
  }
  return 'You do not have permission to run Scientific AI models. Ask your tenant admin for access.';
}
